<footer class="grid gap-1.5 lg:grid-cols-[2fr_1fr_2fr] bg-white border-t border-border w-full py-4 px-10 md:px-14 lg:px-20 bottom-0 relative">
    <div class="text-xs">{{ 'copyright' | translate }}</div>

    <img [src]="logo" class="w-32 self-center lg:justify-self-center" alt="" />

    <div class="absolute bottom-0 right-0">
        <app-version />
    </div>
</footer>
